export default {
    navigationBarTitleText: ''
};